import { InvariantError } from "../../utilities/globals/index.js";
export var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = __DEV__ ? new InvariantError("Network request failed. ".concat(label, " is not serializable: ").concat(e.message)) : new InvariantError(24);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
//# sourceMappingURL=serializeFetchParameter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/http/serializeFetchParameter.js
// module id = 577
// module chunks = 4